import { Component } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { LocationService } from '@callrail/looky/util';
import { AssetsService } from '@callrail/looky/ui';
import { CognitoUserPoolConfigService } from '@callrail/looky/common/core/shared';
import { take } from 'rxjs';

@Component({
  selector: 'anbs-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['sso.component.scss'],
  standalone: false,
})
export class SSOComponent {
  public emailInput = new UntypedFormControl('', [
    Validators.required,
    Validators.email,
  ]);

  constructor(
    private locationService: LocationService,
    public assetsService: AssetsService,
    private userPoolConfig: CognitoUserPoolConfigService
  ) {}

  public singleSignOn() {
    if (this.emailInput.valid) {
      const emailDomain = this.emailInput.value.split('@')[1];
      this.userPoolConfig.userPoolConfig$.pipe(take(1)).subscribe({
        next: ({ oauth_domain, client_id }) => {
          const redirectUri = `${this.locationService.protocol}//${this.locationService.host()}/authenticate/`;
          const scopes = [
            'phone',
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
          ];
          let url = `https://${oauth_domain}/authorize`;
          url += `?response_type=code&client_id=${client_id}`;
          url += `&idp_identifier=${emailDomain}`;
          url += `&redirect_uri=${encodeURIComponent(redirectUri)}`;
          url += `&scope=${encodeURIComponent(scopes.join(' '))}`;
          this.locationService.go(url, true);
        },
      });
    }
  }
}
